import React, { Component } from 'react'
import Header from './components/Header'
import Footer from './components/Footer'
import Input from './components/Input'
import DropSearch from './components/DropSearch'
import LangBtns from './components/LangBtns'
import { connect } from 'react-redux'
import Editor from './components/Editor'
import { changeStateValue, resetStateValue } from '../../redux/MainReducer'
import ImageInp from './components/ImageInp'
import VideoInp from './components/VideoInp'
import SvgInp from './components/SvgInp'
import MultiImage from './components/MultiImage'
import CompImgInp from './components/CompImgInp'
import TextArea from './components/TextArea'
import { getSubCategoriesFilter } from '../../actions/MainAction'
import Image2Inp from './components/Image2Inp'
import Image3Inp from './components/Image3Inp'
import Image4Inp from './components/Image4Inp'
export class MainModal extends Component {
  changeTextValue=(value, name)=>{
    this.props.changeStateValue({
      name: name,
      value:value
    })
  }

  callParent=(id)=>{
    if(this.props.mainModal?.selectSub){
      this.props.changeStateValue({name:"subCategoryDataFilter", value:[]})
      this.props.changeStateValue({name:"mainModal.sub_category_id", value:""})
      this.props.getSubCategoriesFilter(id)
    }
    
  }
  getDroopValue(arr, label, value){
    let newArr = [];
    for(const item of arr){
        newArr.push({
            label: item?.translate[label],
            value: item[value],
        })
    }
    return newArr
}


  render() {
    const {languages, mainModal, subCategoryDataFilter} = this.props;
    console.log(subCategoryDataFilter)
    return (
      <div className='background_shadow flex justify-center items-center'>
        <div className={`bg-white rounded-[10px] shadow w-[800px] max-h-[70vh] ${mainModal?.nonOverflow?"":"overflow-auto"}`}>
            <Header title="title" onCloseBtn={()=>{this.props.resetStateValue({name:"mainModal"})}} />
            {/* <LangBtns params={mainModal.languages} languages={languages} /> */}
            {mainModal?.images || mainModal?.images?.length === 0? <MultiImage images={mainModal?.images} />:null}
            <div className='grid-full-250 p-[20px]  relative z-3'>
            
                {mainModal?.image || mainModal?.image===""?<ImageInp />:null }
                {mainModal?.image_2 || mainModal?.image_2===""?<Image2Inp />:null }
                {mainModal?.image_3 || mainModal?.image_3===""?<Image3Inp />:null }
                {mainModal?.image_4 || mainModal?.image_4 ===""?<Image4Inp />:null }

                
                {mainModal?.category_id || mainModal?.category_id===""?<DropSearch callParent={this.callParent.bind(this)} options={mainModal?.categoryOption} name="mainModal.category_id" title="Kateqoriya seçin" value={mainModal?.category_id} placeholder="Kateqoriya seçin" />:null }
                {mainModal?.selectSub && subCategoryDataFilter.length !== 0?<DropSearch  options={this.getDroopValue(subCategoryDataFilter, "title", "id")} name="mainModal.sub_category_id" title="Alt Kateqoriya seçin" value={mainModal?.sub_category_id} placeholder="Alt Kateqoriya seçin" />:null }


                {mainModal?.company_image || mainModal?.company_image===""?<CompImgInp />:null }
                {mainModal?.svg || mainModal?.svg===""?<SvgInp />:null }
                {mainModal?.video || mainModal?.video===""?<VideoInp />:null }
                {mainModal?.title || mainModal?.title === "" ? <Input required name={"mainModal.title"} value={mainModal?.title} title="Title" />:null }
                {mainModal?.pathTitle || mainModal?.pathTitle === "" ? <Input required name={"mainModal.pathTitle"} value={mainModal?.pathTitle} title="Path" />:null }
                {mainModal?.property || mainModal?.property === "" ? <Input required name={"mainModal.property"} value={mainModal?.property} title="property" />:null }
                {mainModal?.path || mainModal?.path === "" ? <Input required name={"mainModal.path"} value={mainModal?.path} title="Path" />:null }
                {mainModal?.count || mainModal?.count === "" ? <Input required name={"mainModal.count"} value={mainModal?.count} title="Count" />:null }
                {mainModal?.map || mainModal?.map === "" ? <Input required name={"mainModal.map"} value={mainModal?.map} title="map" />:null }
                {mainModal?.address || mainModal?.address === "" ? <Input  name={"mainModal.address"} value={mainModal?.address} title="address" />:null }
                {mainModal?.address_1 || mainModal?.address_1 === "" ? <Input  name={"mainModal.address_1"} value={mainModal?.address_1} title="Voltmills address" />:null }
                
                {mainModal?.phone_1 || mainModal?.phone_1 === "" ? <Input  name={"mainModal.phone_1"} value={mainModal?.phone_1} title="Phone number" />:null }
                {mainModal?.phone_2 || mainModal?.phone_2 === "" ? <Input  name={"mainModal.phone_2"} value={mainModal?.phone_2} title="Voltmills phone number" />:null }
                {mainModal?.phone_3 || mainModal?.phone_3 === "" ? <Input  name={"mainModal.phone_3"} value={mainModal?.phone_3} title="phone number 3" />:null }
                {mainModal?.whatsapp_1 || mainModal?.whatsapp_1 === "" ? <Input  name={"mainModal.whatsapp_1"} value={mainModal?.whatsapp_1} title="whatsapp number" />:null }
                {mainModal?.whatsapp_2 || mainModal?.whatsapp_2 === "" ? <Input  name={"mainModal.whatsapp_2"} value={mainModal?.whatsapp_2} title="Voltmills whatsapp number" />:null }
                {mainModal?.whatsapp_3 || mainModal?.whatsapp_3 === "" ? <Input  name={"mainModal.whatsapp_3"} value={mainModal?.whatsapp_3} title="whatsapp number 3" />:null }
                
                {mainModal?.whatsapp_number || mainModal?.whatsapp_number === "" ? <Input required name={"mainModal.whatsapp_number"} value={mainModal?.whatsapp_number} title="whatsapp number" />:null }
                {mainModal?.email || mainModal?.email === "" ? <Input  name={"mainModal.email"} value={mainModal?.email} title="email" />:null }
                {mainModal?.email_1 || mainModal?.email_1 === "" ? <Input  name={"mainModal.email_1"} value={mainModal?.email_1} title="Voltmills email" />:null }
                {mainModal?.facebook || mainModal?.facebook === "" ? <Input required name={"mainModal.facebook"} value={mainModal?.facebook} title="facebook" />:null }
                {mainModal?.instagram || mainModal?.instagram === "" ? <Input  name={"mainModal.instagram"} value={mainModal?.instagram} title="instagram" />:null }
                {mainModal?.youtube || mainModal?.youtube === "" ? <Input  name={"mainModal.youtube"} value={mainModal?.youtube} title="youtube" />:null }
                {mainModal?.blog_id || mainModal?.blog_id === "" ? <DropSearch options={mainModal?.dropValue} required name={"mainModal.blog_id"} value={mainModal?.blog_id} title="Select a project"  placeholder="Select a project" />:null }


                {mainModal?.languages?.title || mainModal?.languages?.title === "" ? <Input required name={"mainModal.languages.title"} value={mainModal?.languages?.title} title="Title" />:null }
                {mainModal?.languages?.sub_title || mainModal?.languages?.sub_title === "" ? <Input required name={"mainModal.languages.sub_title"} value={mainModal?.languages?.sub_title} title="Sub title" />:null }
                {mainModal?.languages?.position || mainModal?.languages?.position === "" ? <Input required name={"mainModal.languages.position"} value={mainModal?.languages?.position} title="Position" />:null }
                {mainModal?.languages?.user_name || mainModal?.languages?.user_name === "" ? <Input required name={"mainModal.languages.user_name"} value={mainModal?.languages?.user_name} title="Username" />:null }
                {mainModal?.languages?.value || mainModal?.languages?.value === "" ? <Input required name={"mainModal.languages.value"} value={mainModal?.languages?.value} title="Value" />:null }
                {/* {mainModal?.languages?.text || mainModal?.languages?.text === "" ? <Input required name={"mainModal.languages.text"} value={mainModal?.languages?.text} title="Text" />:null } */}
                {/* <Input title="Title" /> */}
                {/* <DropSearch  /> */}
            </div>
           <div className='pl-[20px] pr-[20px]'>
           {
              mainModal?.languages?.text || mainModal?.languages?.text === ""?
              <TextArea title="Text" onChange={(value, name)=>this.changeTextValue(value, name)} value={mainModal?.languages?.text} name={"mainModal.languages.text"} />:null
            }
           {
              mainModal?.languages?.description || mainModal?.languages?.description === ""?
              <Editor required={true} onChange={(value, name)=>this.changeTextValue(value, name)} value={mainModal?.languages?.description} name={"mainModal.languages.description"} />:null
            }
           </div>
            <Footer mainModal={mainModal} />
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  languages: state.Data.languages,
  mainModal: state.Data.mainModal,
  subCategoryDataFilter: state.Data.subCategoryDataFilter,
});
const mapDispatchToProps = {changeStateValue, resetStateValue, getSubCategoriesFilter}
export default connect(mapStateToProps, mapDispatchToProps)(MainModal)